export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/aadf7e204ac3ecb8628e2b693a3c4a40.svg";